(function () {
  const transitionType = "cubic-bezier(.165, .84, .44, 1)";

  const slideUp = (element, duration = 500) => {
    if (!element) return;
    const height = element.getBoundingClientRect().height;

    element.style.height = `${height}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ${transitionType}, opacity ${duration}ms ${transitionType}`;

    void element.offsetHeight;

    element.style.height = "0";
    element.style.opacity = "0";
    const cleanup = () => {
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
      element.removeEventListener("transitionend", cleanup);
    };

    element.addEventListener("transitionend", cleanup);
  };

  const slideDown = (element, duration = 500) => {
    if (!element) return;

    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;
    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.opacity = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ${transitionType}, opacity ${duration}ms ${transitionType}`;

    void element.offsetHeight;

    element.style.height = `${height}px`;
    element.style.opacity = "1";
  };

  const setDefaultHeight = (section) => {
    if (!section || !section?.classList.contains("collapsible-content-section"))
      return;
    const toggles = section.querySelectorAll(".collapsible-content__item");
    toggles.forEach((item) => {
      if (item.getAttribute("data-opened") === "true") {
        const answer = item.querySelector(".collapsible-content__answer");
        answer.style.height = `${answer.scrollHeight}px`;
      }
    });
  };

  const initCollapsibleContent = (section) => {
    if (!section?.classList.contains("collapsible-content-section")) return;

    const toggles = section.querySelectorAll(".collapsible-content__item");

    const addClickListeners = () => {
      toggles.forEach((toggle) => {
        toggle.removeEventListener("mouseenter", handleHover);
        toggle.addEventListener("click", handleClick);
      });
    };

    const addHoverListeners = () => {
      toggles.forEach((toggle) => {
        toggle.removeEventListener("click", handleClick);
        toggle.addEventListener("mouseenter", handleHover);
      });
    };

    const handleClick = (event) => {
      const item = event.currentTarget;
      const answer = item.querySelector(".collapsible-content__answer");

      if (item.classList.contains("active")) {
        slideUp(answer);
        item.classList.remove("active");
      } else {
        toggles.forEach((toggle) => {
          if (toggle !== item) {
            toggle.classList.remove("active");
            slideUp(toggle.querySelector(".collapsible-content__answer"));
          }
        });
        item.classList.add("active");
        slideDown(answer);
      }
    };

    const handleHover = (event) => {
      const item = event.currentTarget;
      const answer = item.querySelector(".collapsible-content__answer");
      if (item.classList.contains("active")) return;
      toggles.forEach((toggle) => {
        if (toggle !== item) {
          toggle.classList.remove("active");
          slideUp(toggle.querySelector(".collapsible-content__answer"));
        }
      });
      item.classList.add("active");
      slideDown(answer);
    };

    let currentMode = null;

    const updateListeners = (mode) => {
      if (mode === currentMode) return;
      currentMode = mode;
      if (mode === "click") {
        addClickListeners();
      } else {
        addHoverListeners();
      }
    };

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    updateListeners("click");
  }
});

resizeObserver.observe(section);
updateListeners("click");

    toggles.forEach((toggle) => {
      toggle.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          handleClick({ currentTarget: toggle });
        }
      });
    });
  };

  setDefaultHeight(document.currentScript.parentElement);
  initCollapsibleContent(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    setDefaultHeight(event.target);
    initCollapsibleContent(event.target);
  });
})();
